import styled from 'styled-components';

import { StyledFlex } from '@dreryk/react-components';

export const StyledHorizontalScrollerContainer = styled(StyledFlex)`
   position: relative;
   width: 100%;
   overflow-x: hidden;
`;

StyledHorizontalScrollerContainer.displayName = 'StyledHorizontalScrollerContainer';

export const StyledHorizontalScrollerItemsContainer = styled.div`
   display: flex;
   gap: 12px;
   overflow-x: auto;
   overflow-y: hidden;

   scrollbar-width: none; /* for firefox */
   -ms-overflow-style: none; /* for edge */

   &::-webkit-scrollbar {
      height: 0px; /* chrome and safari */
   }
`;

StyledHorizontalScrollerItemsContainer.displayName = 'StyledHorizontalScrollerItemsContainer';
